export const en = {
    'first-n-items-will-be-selected': {
        one: 'The first {count} adjustment will be selected',
        some: 'The first {count} adjustments will be selected',
        many: 'The first {count} adjustments will be selected',
        none: ''
    },
    'max-items-number-selected': 'You have selected the maximum number of adjustments',
    'more-than-max-items-number-selected': {
        one: 'You can select a maximum of {count} adjustments',
        some: 'You can select a maximum of {count} adjustments',
        many: 'You can select a maximum of {count} adjustments',
        none: ''
    },
    'no-results-text': 'Make sure there are no errors in the query, or try a shorter one',
    'no-results-title': 'No results found'
};
